import React from "react"

export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.28 29.73"><path d="M42.28,14.89s0,6.93-.89,10.25a5.23,5.23,0,0,1-3.73,3.7c-3.3.89-16.52.89-16.52.89s-13.22,0-16.52-.89a5.24,5.24,0,0,1-3.74-3.7C0,21.82,0,14.89,0,14.89S0,8,.88,4.65A5.32,5.32,0,0,1,4.62.89C7.92,0,21.14,0,21.14,0S34.36,0,37.66.89a5.31,5.31,0,0,1,3.73,3.76C42.28,8,42.28,14.89,42.28,14.89Zm-14.41,0-11-6.28V21.18Z"/></svg>
)
